<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">inventory</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Incluir kit</h2>
    <p class="modal-subtitle">Itens</p>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
      (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="vkd-conteudo" [formGroup]="form">
  <!-- O que está sendo incluído -->
  <div class="vkd-cabecalho">
    <span class="vkd-badge">Kit</span>
    <div class="vkd-identificacao">
      <span class="vkd-nome">{{ data.produto.descricao }}</span>
      <span class="vkd-apoio">
        {{ plano.componentes.length }} {{ plano.componentes.length === 1 ? 'componente' : 'componentes' }}
        @if (data.produto.codigoSku) { · SKU {{ data.produto.codigoSku }} }
        · {{ isPrecoFixo ? 'preço fixo — o preço do kit é rateado entre os componentes' : 'soma dos componentes — o preço de cada componente é editável na grade' }}
      </span>
    </div>
  </div>

  @if (semComponentes) {
    <app-alert-card type="warning" title="Kit sem componentes">
      Este kit não tem componentes cadastrados. Cadastre a composição em Cadastros ▸ Produtos antes de incluí-lo.
    </app-alert-card>
  } @else if (semPreco) {
    <app-alert-card type="warning" title="Kit sem preço">
      Nenhuma lista de preço vigente precifica este kit nem os seus componentes. Ele entra com preço zero.
    </app-alert-card>
  }

  <div class="row vkd-campos">
    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Qtde de kits</mat-label>
        <input matInput formControlName="quantidadeKits" [currencyMask]="data.mascaraInteira" class="vkd-num" inputmode="numeric">
        @if (form.get('quantidadeKits')?.invalid && form.get('quantidadeKits')?.touched) {
          <mat-error>Informe uma quantidade maior que zero.</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Preço do kit</mat-label>
        <input matInput formControlName="precoKit" [currencyMask]="data.mascaraPreco" class="vkd-num">
        @if (isPrecoFixo) {
          <mat-hint>Abaixo da lista vira desconto; acima reescreve a lista.</mat-hint>
        } @else {
          <mat-hint>Soma dos componentes pelo preço de lista de cada um.</mat-hint>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Desconto do kit (%)</mat-label>
        <input matInput formControlName="percentualDescontoKit" [currencyMask]="data.mascaraPercentual" class="vkd-num">
        @if (excedeuOTeto) {
          <mat-icon matSuffix class="material-symbols-outlined vkd-icone-teto"
            matTooltip="Acima do limite do seu perfil. O documento vai pedir liberação ao salvar.">warning</mat-icon>
        }
        <mat-hint>Aplicado a todos os componentes.</mat-hint>
      </mat-form-field>
    </div>
  </div>

  @if (!plano.fechouNoPreco) {
    <app-alert-card type="warning" title="O preço do kit não fecha nas casas de preço da empresa">
      Com {{ plano.quantidadeKits | abnt: 'quantidade' }} kit(s) a soma dos componentes não alcança exatamente
      {{ totalGeral | abnt: 'preco' : 2 }}. Ajuste o preço do kit ou a quantidade, ou revise a composição no cadastro.
    </app-alert-card>
  }

  @if (excedeuOTeto) {
    <app-alert-card type="warning" title="Desconto acima do limite">
      O limite deste perfil é de {{ data.tetoDesconto }}%. O documento vai pedir liberação ao salvar.
    </app-alert-card>
  }

  <!-- Componentes, em leitura, com o preço resultante -->
  @if (!semComponentes) {
    <div class="vkd-tabela">
      <div class="vkd-linha vkd-titulo">
        <span>Componente</span>
        <span class="vkd-num">Por kit</span>
        <span class="vkd-num">Qtde</span>
        <span class="vkd-num">Preço un</span>
        <span class="vkd-num">Total</span>
      </div>
      @for (c of plano.componentes; track c.produto.idProduto) {
        <div class="vkd-linha">
          <span class="vkd-componente">
            <span class="vkd-componente-nome">{{ c.produto.descricao }}</span>
            <span class="vkd-componente-apoio">
              @if (c.produto.codigoSku) { SKU {{ c.produto.codigoSku }} · }
              {{ c.produto.unidade || 'UN' }}
              @if (c.precoBase <= 0) { · sem preço de lista }
            </span>
          </span>
          <span class="vkd-num">{{ c.quantidadeComposicao | abnt: 'quantidade' }}</span>
          <span class="vkd-num">{{ c.quantidade | abnt: 'quantidade' }}</span>
          <span class="vkd-num">{{ c.precoLiquidoUnitario | abnt: 'preco' }}</span>
          <span class="vkd-num vkd-forte">{{ c.valorTotal | abnt: 'preco' : 2 }}</span>
        </div>
      }
      <div class="vkd-linha vkd-rodape">
        <span>Total por kit {{ totalPorKit | abnt: 'preco' : 2 }}</span>
        <span></span><span></span><span></span>
        <span class="vkd-num vkd-forte">{{ totalGeral | abnt: 'preco' : 2 }}</span>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="vkd-acoes">
  <button type="button" mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button type="button" mat-flat-button class="btn-primary" [disabled]="semComponentes || !plano.fechouNoPreco" (click)="confirmar()">Incluir kit</button>
</mat-dialog-actions>
